import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

import {useRoute} from 'vue-router';
import {onMounted, reactive, UnwrapRef} from "vue";
import {getDentistPatientsInCharge, setPatientInCharge} from "@/api/patient";
import {getDentistTeam} from "@/api/dentist_team";

interface Data {
  inChargeId: any,
  loading: boolean
  inChargeIds: any[],
  options: any[]
  selected: any[]
  dataSource: any[]
}



export default /*#__PURE__*/_defineComponent({
  __name: 'in_charge',
  setup(__props) {

const route = useRoute();


let data: UnwrapRef<Data> = reactive({
  inChargeId: '',
  loading: false,
  inChargeIds: [],
  options: [],
  dataSource: [],
  selected: []
});

const init = () => {
  getDentistTeamById(route.query.id)
  getDentistTeamPatients(route.query.dentistId);
}


const getDentistTeamPatients = (id: any) => {
  getDentistPatientsInCharge(id).then((res: any) => {
    data.dataSource = res
  })
}

const getDentistTeamById = (id: any) => {
  if (data.options.length > 0) return
  getDentistTeam(id).then((res: any) => {
    if (null != res.dentists) {
      res.dentists.forEach((val: any) => {
        const item = {'value': val.id, 'label': val.person.firstName}
        data.options.push(item)
      });
    }
  })
}


const edit = (record: any) => {
  console.log(record);
  data.inChargeId = record.inChargeId
  data.selected[record.id] = true;
}

const save = (record: any) => {
  setPatientInCharge(record.id, data.inChargeId).then(() => {
    getDentistTeamPatients(route.query.dentistId)
  })
  data.selected[record.id] = false;
}

const onInChargeChanged = (val: number) => {
  console.log(val)
  data.inChargeId = val;
}

onMounted(async () => {
  init()
});

const columns = [
  {
    title: "客户",
    dataIndex: "patient",
    key: "patient",
    width: 200
  },

  {
    title: "负责人",
    dataIndex: "inCharge",
    key: "inCharge",
    width:300
  },
  {
    title: "操作",
    dataIndex: "operation",
  },
];


return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      dataSource: _unref(data).dataSource,
      columns: columns,
      loading: _unref(data).loading
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'patient')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (null != record.patient)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(record.patient.person.firstName), 1))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'inCharge')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (null != record.inCharge &&  !_unref(data).selected[record.id])
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.inCharge.person.firstName), 1))
                : _createCommentVNode("", true),
              (_unref(data).selected[record.id])
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 1,
                    value: _unref(data).inChargeId,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).inChargeId) = $event)),
                    options: _unref(data).options,
                    onChange: onInChargeChanged,
                    style: {"width":"180px"}
                  }, null, 8, ["value", "options"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation' )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_unref(data).selected[record.id])
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "ghost",
                    onClick: ($event: any) => (edit(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("设定")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_unref(data).selected[record.id])
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    onClick: ($event: any) => (save(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading"])
  ]))
}
}

})